<template>
    <el-container class="login-container container_100">
        <div class="login-wraper">
            <div v-if="isTx" class="title">团险业务系统</div>
            <div v-else class="title">保险师团险业务系统</div>
            <template v-if="isTx">
                <el-form
                    ref="formValidate"
                    @keydown.enter.native="tx_submit_login"
                    :model="formInfo" >
                    <template v-if="isMobile">
                        <form-item required prop="mobile" :forms="formManege.mobile"/>
                        <form-item required prop="validateCode" :forms="formManege.validateCode">
                            <template slot="suffix">
                                <form-button type="text" @click="getSmsCode">获取验证码</form-button>
                            </template>
                        </form-item>
                    </template>
                    <template v-else>
                        <form-item required prop="userName" :forms="formManege.userName"/>
                        <el-form-item required prop="password" :rules="[{ required: true, message: '请输入密码'}]">
                            <el-input v-model="formInfo.password" :type="`${flag ? 'text':'password'}`" :placeholder="formManege.password.tips" :show-password="false" autocomplete="new-password" >
                                <template #suffix>
                                    <span @click="flag = !flag">
                                        <img style="margin-top: 7px;" src="../../images/tx-icon-hide.png" v-if="flag == true" />
                                        <img style="margin-top: 8px;" src="../../images/tx-icon-view.png" v-else-if="flag == false" />
                                    </span>
                                </template>
                            </el-input>
                        </el-form-item>
                    </template>
                    <form-item>
                        <form-button class="submit-btn" size="medium" @click="tx_submit_login">登录</form-button>
                        <el-button class="change-login-btn" size="default" type="text" @click="changeLoginMethod">{{ changeLoginTitle }}</el-button>
                    </form-item>
                </el-form>
            </template>
            <template v-else>
                <el-form
                    ref="formValidate"
                    @keydown.enter.native="submit_login"
                    :model="formInfo" >
                    <form-item required prop="mobile" :forms="formManege.mobile"/>
                    <form-item required prop="validateCode" :forms="formManege.validateCode">
                        <template slot="suffix">
                            <form-button  type="text" @click="getSmsCode">获取验证码</form-button>
                        </template>
                    </form-item>
                    <form-item>
                        <form-button class="submit-btn" size="medium" @click="submit_login">登录</form-button>
                    </form-item>
                </el-form>
            </template>
        </div>
        <c-footer-new :isTXSystem="isTx" class="footer-wraper"></c-footer-new>
    </el-container>
</template>

<script>
import Api from '@/api'
import {
    checkPhone,
    getObjVal,
} from 'tools'
import CFooterNew from '_c/www2/c-footer.vue'
export default {
    name: 'login',
    props: {
        isTx: {
            default: false
        }
    },
    data() {
        return {
            formManege: {
                mobile: {
                    tips: '请输入保险师注册手机号'
                },
                validateCode: {
                    tips: '请输入验证码',
                    slot: 'suffix',
                },
                userName: {
                    tips: '请输入账号'
                },
                password: {
                    tips: '请输入密码',
                }
            },
            formInfo: {
                mobile: '',
                validateCode: '',
                userName: '',
                password: '',
            },
            isMobile: false,
            changeLoginTitle: '短信验证码登录',
            flag: false,
        }
    },
    methods: {
        getSmsCode(){
            const { mobile } = this.formInfo;
            let msg = '';
            if(!mobile) msg = '请输入保险师注册手机号';
            else if(!checkPhone(mobile)) msg = '请填写正确的手机号'
            if(msg) return this.$tipsMessage(msg);

            const loading = this.$loading()
            return Api.getSms({
                mobile,
                type: this.isTx ? 2 : 1
            }).then((rep) => {
                loading.close()
                // if(rep.msg) {
                //     this.$tipsMessage(rep.msg,1);
                // }
                if (rep.data) {
                    this.$tipsMessage(rep.data,1);
                }
            }).catch((err)=>{
                loading.close()
                // if(err && err.msg){
                //     this.$tipsMessage(err.msg);
                // };
                if(err && err.info){
                    this.$tipsMessage(err.info);
                };
            });
        },
        submit_login(){
            return this._validate(this._login);
        },
        _validate(callBack){
            return this.$refs['formValidate'] && this.$refs['formValidate'].validate((valid,props) => {
                if(valid) return callBack && callBack();
            })
        },
        _login(){
            const loginForm = this.formInfo;
            this.$store.dispatch('Login', loginForm).then(rep => {
                // this.$message.success({
                //     message: rep.info || '登录成功'
                // })
                let token = rep.data.token //utils.getCookie('token')
                let param = {
                    token,
                }
                // this.$store.dispatch('setcookies', param).then(res => {
                    this.$message.success({
                        message: '登录成功'
                    })
                    // window.location.reload()
                    if (this.$store.getters.goPageAfterLogin) {
                        this.$router.go(0)
                        this.$router.push(this.$store.getters.goPageAfterLogin)
                        this.$store.commit('SET_GO_PAGE', '')
                    } else {
                        this.$router.go(0)
                    }
                // }).catch(err => {
                //     this.$message.success({
                //         message: '登录成功'
                //     })
                //     // this.$store.commit('SET_LOGIN_MODAL', false)
                //     if (this.$store.getters.goPageAfterLogin) {
                //         // this.$router.go(0)
                //         this.$router.push(this.$store.getters.goPageAfterLogin)
                //         this.$store.commit('SET_GO_PAGE', '')
                //         // this.$router.go(0)
                //     } else {
                //         this.$router.go(0)
                //     }
                // })
                // if (this.$store.getters.goPageAfterLogin) {
                //     this.$router.push(this.$store.getters.goPageAfterLogin)
                //     this.$store.commit('SET_GO_PAGE', '')
                // } else {
                //     this.$router.go(0)
                // }
            }).catch(e => {
                const errMsg = getObjVal(e,'info') || getObjVal(e,'msg')
                if (errMsg) this.$message.error({ message: errMsg })
            })
        },
        changeLoginMethod() {
            this.isMobile = !this.isMobile
            this.changeLoginTitle = this.isMobile ? '密码登录' : '短信验证码登录'
            this.formInfo = { mobile: '', validateCode: '', userName: '', password: ''}
            this.$refs['formValidate'] && this.$refs['formValidate'].clearValidate()
        },
        tx_submit_login() {
            return this._validate(this._tx_login);
        },
        _tx_login(){
            const loginForm = {}
            if (this.isMobile) {
                const params = {loginType: 2, mobile: this.formInfo.mobile, validateCode: this.formInfo.validateCode}
                Object.assign(loginForm, params)
            } else {
                const params = {loginType: 1, userName: this.formInfo.userName, password: this.formInfo.password}
                Object.assign(loginForm, params)
            }

            this.$store.dispatch('OauthLogin', loginForm).then(rep => {
                let token = rep.data.token //utils.getCookie('token')
                let param = {
                    token,
                }
                // this.$store.dispatch('setcookies', param).then(res => {
                    this.$message.success({
                        message: '登录成功'
                    })
                    if (this.$store.getters.goPageAfterLogin) {
                        this.$router.push(this.$store.getters.goPageAfterLogin)
                        this.$store.commit('SET_GO_PAGE', '')
                    } else {
                        this.$router.go(0)
                    }
                // }).catch(err => {
                //     this.$message.success({
                //         message: '登录成功'
                //     })
                //     if (this.$store.getters.goPageAfterLogin) {
                //         this.$router.push(this.$store.getters.goPageAfterLogin)
                //         this.$store.commit('SET_GO_PAGE', '')
                //     } else {
                //         this.$router.go(0)
                //     }
                // })
            }).catch(e => {
                if (e && e.info) this.$message.error({ message: e.info })
                if (e && e.msg) this.$message.error({ message: e.msg })
            })
        },
    },
    created(){
    },
    components: {
        CFooterNew
    },
    computed: {
    },
    watch: {
        isTx: {
            handler(val) {
                this.formManege.mobile.tips = val ? '请输入手机号' : '请输入保险师注册手机号'
            },
            immediate: true
        }
    }
}
</script>
<style lang="less">
@import "./login.less";
</style>




// WEBPACK FOOTER //
// src/components_v3/login/login.vue